<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
     News & Notifications
    </div>
    <div class="content">
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(item, index) in items" :key="index">
          <div class="horizontal items-center justify-center">
            <van-image :src="item" fit="contain" height="448px" show-loading>
              <template v-slot:loading>
                <van-loading type="spinner" size="50"/>
              </template>
            </van-image>
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="flex flex-col items-center">
            <div class="horizontal items-center justify-center mt-4" style="background: #F1F1F1;width:88px;">
              <div class="indicator" :class="index === current ? 'active':''" v-for="(item,index) in items">

              </div>
            </div>
          </div>
        </template>
      </van-swipe>

      <div v-html="content" class="mt-3 pl-3 p-3">
      </div>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";
import router from "@/router";

export default {
  name: "NotificationDetail",
  data() {
    return {
      items: [],
      content: "",
      current: 0
    };
  },
  methods: {
    onClickHeaderReturn() {
      this.$router.back()
    },
    onChange(index) {
      this.current = index;
    }
  },
  async mounted() {
    const newsId = this.$route.query.newsId;
    if (!newsId) {
      this.$toast({
        message: "News & Notification not found"
      });
      return;
    }

    const data = await user.eventDetail({
      id: newsId
    });
    this.items = data.eventCarouselImage.split(",");
    this.content = data.eventContent;
  }
};
</script>

<style scoped lang="less">
.container {
  background: white;


  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;
    background: white;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }


  .content {
    font-weight: lighter;
    background: white;
    font-size: 14px;
    font-family: 'outfit-thin';
    font-weight: 100;
    padding: env(safe-area-inset-bottom);

    ::v-deep p {
      line-height: 1.5 !important;
    }
    ::v-deep img {
      margin: 8px 0;
      width:100%;
    }
  }
}

.indicator {
  width: 20px;
  height: 4px;
}

.active {
  background: #679AFF;
}


</style>